import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconVisibilityOff = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconVisibilityOff",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M764-84 624-222q-35 11-71 17t-73 5q-134 0-245-72T61-462q-5-9-7-18t-3-20 3-19 7-19q22-39 47-76t58-66l-83-84q-11-11-11-27t12-29q11-11 28-11t28 11l680 680q11 11 12 28t-12 28q-11 11-28 11t-28-11M480-320l21-1 20-4-216-216-4 20-1 21q0 75 53 128t127 52m0-480q134 0 246 73t174 190q5 8 8 18t2 19l-2 20q-2 10-7 17-19 37-42 70t-53 62q-14 14-33 13t-33-15l-80-80q-7-7-9-16t1-20l6-25q2-12 2-26 0-75-52-127t-128-53q-14 0-26 2t-25 6q-10 3-20 1t-17-9l-33-33q-19-19-12-44t31-32q25-5 51-8t51-3m79 226q11 13 19 29t9 32q1 8-6 11t-13-3l-82-82q-6-6-2-13t11-7q19 2 35 11t29 22"
  })
}));
IconVisibilityOff.displayName = 'IconVisibilityOff';